import { ReactNode } from 'react';
import styled from '@emotion/styled';

export interface headerCaptionProps {
  width?: string;
  color?: string;
  textAlign?: string;
  heading?: string;
  headingLength?: string | number;
  headingSize?: string;
  headingMargin?: string;
  headingColor?: string;
  showHeading?: boolean;
  caption?: string;
  captionLength?: string | number;
  captionSize?: string;
  captionMargin?: string;
  captionColor?: string;
  marginTop?: string;
  showCaption?: boolean;
  renderIcon?: () => ReactNode;
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  children?: ReactNode | ReactNode[];
  showHeadingRightContent?: () => ReactNode;
  onClick?: () => void;
  headingJustify?: string;
  headingAlign?: string;
  headingFlex?: string
  headingDisplay?: string
}

export const Container = styled.div<headerCaptionProps>`
  width: ${({ width }) => (typeof width === 'string' ? width : `${width}%`)};
  color: ${({ color }) => color};
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-direction: ${({ flexDirection }) => flexDirection};
  @media (max-width: 768px) {
    width: 90%;
    margin-top: ${({ marginTop }) => marginTop};
  };
  
`;

export const Heading = styled.div<headerCaptionProps>`
  font-size: ${({ headingSize }) =>
    typeof headingSize === 'string' ? headingSize : `${headingSize}px`};
  width: ${({ headingLength }) =>
    typeof headingLength === 'string' ? headingLength : `${headingLength}%`};
  white-space: pre-wrap;
  word-wrap: break-word;
  & > h1 {
    margin: ${({ headingMargin }) => (headingMargin ?? '0px')};
    text-align: ${({ textAlign }) => textAlign};
  };
  color: ${({ headingColor }) => headingColor};
  display: ${({ headingDisplay }) => headingDisplay};
  justify-content: ${({ headingJustify }) => headingJustify};
  align-items: ${({ headingAlign }) => headingAlign};
  flex-direction: ${({ headingFlex }) => headingFlex};
  @media (max-width: 768px) {
    width: 95%;
  };
  
`;

export const Caption = styled(Heading)<headerCaptionProps>`
  font-size: ${({ captionSize }) =>
    typeof captionSize === 'string' ? captionSize : `${captionSize}px`};
  width: ${({ captionLength }) =>
    typeof captionLength === 'string' ? captionLength : `${captionLength}%`};
  & > p {
    margin: ${({ captionMargin }) =>
      captionMargin ?? '18px 0px'};
    text-align: ${({ textAlign }) => textAlign};
  };
  color: ${({ captionColor }) => captionColor};
   @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
  }
`;
